// PLEASE REMOVE THIS FILE ONCE THE NEW THERAPIST LISTING PAGE IS IMPLEMENTED
// IT CONVERTS OLD STYLE QUERY PARAMS TO THE NEW STYLE
export const convertOldQueryParams = (queryString: string): string => {
  const queryParams = new URLSearchParams(queryString);
  const outcode = queryParams.get("outcode");
  const postcode = queryParams.get("postcode");
  const date = queryParams.get("date");

  const newQueryParams = Object.entries({
    ...((postcode || outcode) && { 
      postcode: postcode ?? outcode,
    }),
    ...(date && {
      date: date.slice(0, 10),
      time: date.slice(11, 16),
    }),
  })
  .map(([key, value]) => 
    `${key}=${value}`
  )
  .join("&");

  return `?${newQueryParams}`;
};